/*! Add Changes to `head > style` or `body > script` tags. */
(window.webpackJsonp = window.webpackJsonp || []).push([
    ["totalelement-global"],
    {
        "+Un9": function (t, e, n) {
            "use strict";
            function o(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    (o.enumerable = o.enumerable || !1),
                        (o.configurable = !0),
                        "value" in o && (o.writable = !0),
                        Object.defineProperty(t, o.key, o);
                }
            }
            Object.defineProperty(e, "__esModule", { value: !0 });
            var r = n("hWl5"),
                a = (function () {
                    function t() {
                        !(function (t, e) {
                            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                        })(this, t);
                    }
                    var e, n, a;
                    return (
                        (e = t),
                        (a = [
                            {
                                key: "init",
                                value: function () {
                                    r.ShopifyUtil.ready(function () {
                                        var t = $("#product-quantity-breaks"),
                                            e = $(t.find("tbody").get(0)),
                                            n = parseInt(e.data("price-main")),
                                            o = [];
                                        $.each(e.children(), function (t, e) {
                                            var n = $(e),
                                                r = {
                                                    tierQuantityRaw: n.data("tier-quantity"),
                                                    tierQuantity: parseInt(n.data("tier-quantity")),
                                                    percentOffRaw: n.data("percent-off"),
                                                    percentOff: parseFloat(n.data("percent-off")),
                                                };
                                            o.push(r);
                                        }),
                                            (o = o.sort(function (t, e) {
                                                return e.tierQuantity - t.tierQuantity;
                                            }));
                                        r.ShopifyUtil.moneyFormat(n, moneyFormatWithCurrency, !0);
                                        var a = r.ShopifyUtil.moneyFormat(n, moneyFormatWithCurrency, !0);
                                        $("#quantity").on("change", function (t) {
                                            if (t.currentTarget) {
                                                var e = parseInt($(t.currentTarget).val()),
                                                    i = r.ShopifyUtil.moneyFormat(n, moneyFormatWithCurrency, !0),
                                                    l = $(".is-price-applied");
                                                l && l.length > 0 && l.removeClass("is-price-applied");
                                                var u = !0,
                                                    c = !1,
                                                    p = void 0;
                                                try {
                                                    for (
                                                        var f, s = o[Symbol.iterator]();
                                                        !(u = (f = s.next()).done);
                                                        u = !0
                                                    ) {
                                                        var d = f.value;
                                                        if (e >= d.tierQuantity) {
                                                            $(
                                                                'tr[data-tier-quantity="' +
                                                                    d.tierQuantityRaw +
                                                                    '"][data-percent-off="' +
                                                                    d.percentOffRaw +
                                                                    '"]'
                                                            ).addClass("is-price-applied"),
                                                                (i = r.ShopifyUtil.moneyFormat(
                                                                    n * d.percentOff,
                                                                    moneyFormatWithCurrency,
                                                                    !0
                                                                ));
                                                            break;
                                                        }
                                                    }
                                                } catch (t) {
                                                    (c = !0), (p = t);
                                                } finally {
                                                    try {
                                                        u || null == s.return || s.return();
                                                    } finally {
                                                        if (c) throw p;
                                                    }
                                                }
                                                a !== i &&
                                                    ((a = i), $("#productPrice-product-template > small").html(i));
                                            }
                                        });
                                    });
                                },
                            },
                        ]),
                        (n = null) && o(e.prototype, n),
                        a && o(e, a),
                        t
                    );
                })();
            e.ProductPageCore = a;
        },
        "24a9": function (t, e, n) {
            "use strict";
            function o(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    (o.enumerable = o.enumerable || !1),
                        (o.configurable = !0),
                        "value" in o && (o.writable = !0),
                        Object.defineProperty(t, o.key, o);
                }
            }
            Object.defineProperty(e, "__esModule", { value: !0 });
            var r = (function () {
                function t() {
                    !(function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, t);
                }
                var e, n, r;
                return (
                    (e = t),
                    (r = [
                        {
                            key: "init",
                            value: function () {
                                $(document).ready(function () {
                                    $(".read-more-expand, .read-less").hide(),
                                        $(".read-more-run").click(function (t) {
                                            t.preventDefault();
                                            var e = $($(this).closest(".read-more-block").get(0));
                                            e.find(".read-more-expand").slideDown(125), e.find(".read-more-run").hide();
                                        });
                                }),
                                    (window.modalOpen = function (t) {
                                        $(t).css("display", "block");
                                    }),
                                    (window.modalClose = function (t) {
                                        $(t).css("display", "");
                                    });
                                var t,
                                    e = {
                                        applyTooltips: function (t) {
                                            void 0 === t && (t = ".te-auto-tooltip");
                                            var e = $(t);
                                            e.length > 0 &&
                                                $.each(e, function (t, e) {
                                                    if (!$(e).hasClass("te-auto-tooltip-setup")) {
                                                        $(e).addClass("te-auto-tooltip-setup");
                                                        var n = {};
                                                        $(e).attr("data-trigger") ||
                                                            (n.trigger = "mouseenter focus click"),
                                                            tippy(e, n);
                                                    }
                                                });
                                        },
                                        readyTooltips: function () {
                                            "function" == typeof tippy ? e.applyTooltips() : e.sleepTooltips();
                                        },
                                        sleepTooltips: function () {
                                            setTimeout(e.readyTooltips, 125);
                                        },
                                    };
                                $(document).ready(function (n) {
                                    var o = $(".md-trigger");
                                    $.each(o, function (t, e) {
                                        var n = $(e).data("modal"),
                                            o = $($(n).get(0)).find(".close");
                                        $(e).attr("onClick", 'modalOpen("' + n + '")'),
                                            $.each(o, function (t, e) {
                                                $(e).attr("onClick", 'modalClose("' + n + '")');
                                            });
                                    }),
                                        $(window).resize(function () {
                                            $(window).trigger("window:resize");
                                        });
                                    var r = "desktop",
                                        a = !1,
                                        i = !1;
                                    (t = function () {
                                        var e = $('[id="Kicker Custom 1_1"]'),
                                            n = $("#addToCartForm");
                                        e.length > 0 && n.length > 0
                                            ? ((a = !0),
                                              $(window).width() >= 600
                                                  ? "desktop" !== r &&
                                                    ((r = "desktop"),
                                                    n.prepend(e),
                                                    e.css("margin", ""),
                                                    e.css("float", "right"),
                                                    $('[id="BulkSaveMsg"]').css("padding-top", "10px"))
                                                  : "mobile" !== r &&
                                                    ((r = "mobile"),
                                                    $(".totalElement-estimated-arrival").after(e),
                                                    e.css("margin", "15px 0 15px 0"),
                                                    e.css("float", "left")))
                                            : a || setTimeout(t, 75);
                                    }),
                                        $(window).on("window:resize", function (e) {
                                            !1 !== i && clearTimeout(i),
                                                (i = setTimeout(function () {
                                                    t();
                                                }, 125));
                                        }),
                                        t(),
                                        e.sleepTooltips();
                                });
                            },
                        },
                    ]),
                    (n = null) && o(e.prototype, n),
                    r && o(e, r),
                    t
                );
            })();
            e.OldSiteGlobal = r;
        },
        VERK: function (t, e, n) {},
        awOw: function (t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", { value: !0 });
            var o = n("24a9"),
                r = n("+Un9");
            n("VERK");
            var a = $("body");
            if ((a.hasClass("template-product") && r.ProductPageCore.init(), "your-shopping-cart" === a.attr("id"))) {
                var i = function () {
                    $("#fullscreen-price-reloading").fadeIn(75), $("body").css("overflow", "hidden");
                };
                $(".update-cart").on("click", function (t) {
                    i();
                }),
                    $.each($('[name="updates[]"]'), function (t, e) {
                        e.addEventListener("change", function (t) {
                            i();
                            var e = $(".cart-form");
                            e && e.submit();
                        });
                    });
            }
            $ShippingBanner_v1.run(), o.OldSiteGlobal.init();
        },
        hWl5: function (t, e, n) {
            "use strict";
            function o(t, e) {
                for (var n = 0; n < e.length; n++) {
                    var o = e[n];
                    (o.enumerable = o.enumerable || !1),
                        (o.configurable = !0),
                        "value" in o && (o.writable = !0),
                        Object.defineProperty(t, o.key, o);
                }
            }
            Object.defineProperty(e, "__esModule", { value: !0 });
            var r = (function () {
                function t() {
                    !(function (t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    })(this, t);
                }
                var e, n, r;
                return (
                    (e = t),
                    (n = null),
                    (r = [
                        {
                            key: "ready",
                            value: function (t) {
                                var e = this,
                                    n = "undefined" != typeof Shopify && "function" == typeof Shopify.formatMoney;
                                return (
                                    n
                                        ? t()
                                        : setTimeout(function () {
                                              e.ready(t);
                                          }, 25),
                                    n
                                );
                            },
                        },
                        {
                            key: "moneyFormat",
                            value: function (t, e) {
                                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                                    o = e || moneyFormat,
                                    cleanFormat = o.replace(/\s?[A-Z]{3}$/, ""),
                                    a = cleanFormat
                                        .replace("{{amount}}", "__AMOUNT__")
                                        .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
                                        .replace("__AMOUNT__", "(.+)"),
                                    i = Shopify.formatMoney(t, o);
                                if (n) {
                                    var tempMoney = Shopify.formatMoney(t, cleanFormat),
                                        l = tempMoney.match(a);
                                    if (l) {
                                        var u = l[1],
                                            c = u.split(",").pop(),
                                            p = u.split(".").pop(),
                                            f = (c && !p) || (c && p && c.length < p.length) ? "," : ".",
                                            s = u.split(f),
                                            d = s.pop(),
                                            y = s.join(f) + "<sup>" + d + "</sup>";
                                        i = i.replace(u, y);
                                    }
                                }
                                return i.replace(/\s?USD$/i, "");
                            },
                        },
                    ]),
                    n && o(e.prototype, n),
                    r && o(e, r),
                    t
                );
            })();
            e.ShopifyUtil = r;
        },
    },
]);
/*! Add Changes to `head > style` or `body > script` tags. */
(window.webpackJsonp = window.webpackJsonp || []).push([
    ["_tmp_shared"],
    {
        "Z+sJ": function (n, w, e) {
            e("awOw");
        },
    },
    [["Z+sJ", "runtime", "totalelement-global"]],
]);
